(function () {
    function SignInController($scope, $stateParams, DashboardConfig) {
        function navigateToYumbiSignOn(returnUrl) {
            window.location.href = DashboardConfig.LoginUrl.format(encodeURIComponent(returnUrl));
        }

        function initialise() {
            const { protocol, host, pathname } = window.location;
            const returnURL = $stateParams.returnUrl || `${protocol}//${host}${pathname}`;

            navigateToYumbiSignOn(returnURL);
        }

        initialise();
    }

    angular
        .module("dashboard")
        .controller("SignInController", [
            "$scope",
            "$stateParams",
            "DashboardConfig",
            SignInController
        ]);
})();
